import PlanSummaryCard from "../PlanSummaryCard";
import PriceDetailsCard from "../PriceDetailsCard";
import "./style.scss";
import ActionModal from "components/Settings/components/ActionModal";

function SummaryModal({ open, setOpen, plan, paymentDetails, createPayment }) {
  return (
    <ActionModal
      open={open}
      setOpen={setOpen}
      closable
      width={998}
      className="summary-modal"
      centerMode={false}
    >
      <PlanSummaryCard data={plan} />
      <PriceDetailsCard
        plan={plan}
        paymentDetails={paymentDetails}
        createPayment={createPayment}
      />
    </ActionModal>
  );
}

export default SummaryModal;
